module.exports = __webpack_public_path__ + "img/header-weddingRings.19d1718.webp";